<template>
    <div>
        <p>
          Campos obligatorios <strong :style="{ color: colorAsterisco }">*</strong>
        </p>
    </div>
</template>

<script>
export default {
  name: 'RequiredFields',
  data() {
    return {
      colorAsterisco: '#4b7cf3',
    }
  },
}
</script>
